import { useEffect, useState } from 'react';
import { AVATAAR_SKUS } from '../constants';

export const useAvataar = (itemId) => {
  const showAvataarDefault = AVATAAR_SKUS.some((product) => {
    return product.itemId === itemId;
  });
  const [showAvataarAR, setShowAvataarAR] = useState(false);

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.on('media-gallery.avataar.click', (payload) => {
      setShowAvataarAR(payload?.output?.showAvataar);
    });
    return () => {
      window.LIFE_CYCLE_EVENT_BUS.off('media-gallery.avataar.click');
    };
  }, []);

  useEffect(() => {
    // Load Avataar script
    const AVATAAR_AR_SCRIPT_SRC = 'https://orion.avataar.me/enterpriseIntegration/iframeParent/iframe.js';
    const getLoadedAvataarARScript = () => {
      let scripts = [];
      if (typeof window !== 'undefined' && window.document) {
        scripts = Array.from(document.getElementsByTagName('script'));
      }
      return scripts.find((script) => script.getAttribute('src') === AVATAAR_AR_SCRIPT_SRC);
    };

    if (showAvataarDefault && !getLoadedAvataarARScript()) {
      const script = document.createElement('script');
      script.src = AVATAAR_AR_SCRIPT_SRC;
      script.type = 'text/javascript';
      script.id = 'avataar-script';
      script.async = true;
      document.head.appendChild(script);
    }

    return () => {
      const loadedAvataarARScript = getLoadedAvataarARScript();
      if (loadedAvataarARScript?.parentNode) {
        loadedAvataarARScript.parentNode.removeChild(loadedAvataarARScript);
      }
    };
  }, [showAvataarDefault]);

  return {
    showAvataarDefault,
    showAvataarAR,
    setShowAvataarAR
  };
};